import * as React           from 'react';

import { Container,
         WelcomeVariants,
         welcome_variants } from 'src/components/features/auth/pin-enter/welcome/ui';



type Props = {
  variant: WelcomeVariants;
  children: React.ReactNode;
}
export const Welcome: React.FC<Props> = ({
  variant,
  children,
}) => {
  const lookAndFeel = welcome_variants.get(variant)!;

  return (
    <Container lookAndFeel = { lookAndFeel }>
      { children }
    </Container>
  );
};
